import { IMG } from "@/content/images";

export const SERVICES = [
  {
    slug: "wedding-photography",
    title: "Wedding Photography",
    metaTitle: "Luxury Wedding Photography in Odisha | DMS Productions & Films",
    metaDescription: "Editorial and documentary wedding photography in Bhubaneswar & Odisha capturing authentic emotions and timeless heirloom galleries. Book on WhatsApp.",
    label: "Signature",
    promise:
      "Timeless imagery that captures the honesty of your vows and the joy that surrounds them.",
    intro:
      "Your wedding is a single day that holds a lifetime of emotion. We photograph it the way you will remember it — unhurried, honest and beautifully composed. From the first light of the morning rituals to the final embrace of the night, our approach is discreet, intuitive and deeply personal.",
    hero: IMG.hero[0],
    cover: IMG.couples[0],
    keywords: [
      "wedding photographer Bhubaneswar",
      "luxury wedding photography Odisha",
      "candid wedding photographer Hyderabad",
      "wedding photography Bhubaneswar",
    ],
    includes: [
      "Full-day candid & editorial coverage",
      "Two lead photographers",
      "Hand-finished colour grading",
      "Private online gallery",
      "Fine-art album design",
      "High-resolution digital images",
    ],
    process: [
      { title: "Conversation", text: "We begin with a relaxed chat to understand your story, family and the moments that matter most." },
      { title: "The Day", text: "We move quietly through your celebrations, capturing emotion as it unfolds — never staged, never rushed." },
      { title: "The Heirloom", text: "Your images are carefully curated, graded and presented as a gallery and a fine-art album to keep forever." },
    ],
    gallery: [IMG.couples[1], IMG.indian[0], IMG.details[0], IMG.couples[2], IMG.indian[1], IMG.details[1]],
    relatedStories: ["suchika-sushovan", "madhuja"],
    relatedBlogs: ["choosing-your-wedding-photographer", "timeless-wedding-albums"],
  },
  {
    slug: "pre-wedding-photography",
    title: "Pre Wedding Photography",
    metaTitle: "Pre Wedding Shoot in Bhubaneswar | DMS Productions & Films",
    metaDescription: "Creative pre-wedding shoot photography in Bhubaneswar & Odisha. Romantic, editorial conceptual shoots tailored to your love story. Book on WhatsApp.",
    label: "Together",
    promise:
      "A cinematic prelude to your wedding — the two of you, unposed and in love.",
    intro:
      "Before the celebrations begin, there is a quieter story worth telling — the story of just the two of you. Our pre-wedding sessions are relaxed and cinematic, set against landscapes and light that reflect your personalities. No stiff poses. Only genuine connection, framed with care.",
    hero: IMG.hero[1],
    cover: IMG.couples[3],
    keywords: [
      "pre wedding photography Bhubaneswar",
      "pre wedding shoot Bhubaneswar",
      "pre wedding shoot Puri beach",
      "couple photoshoot Kolkata",
    ],
    includes: [
      "Half or full-day session",
      "Location scouting & guidance",
      "Styling & mood direction",
      "Cinematic colour grade",
      "Curated digital gallery",
      "Optional highlight reel",
    ],
    process: [
      { title: "Concept", text: "We design a mood and choose locations that feel authentically you." },
      { title: "The Session", text: "A calm, playful shoot where we guide you gently and let real moments happen." },
      { title: "Delivery", text: "A refined gallery of images — and optionally a short cinematic film." },
    ],
    gallery: [IMG.couples[4], IMG.couples[5], IMG.couples[6], IMG.couples[7], IMG.couples[8], IMG.details[2]],
    relatedStories: ["seekruti"],
    relatedBlogs: ["pre-wedding-location-ideas-odisha"],
  },
  {
    slug: "destination-wedding-photography",
    title: "Destination Wedding Photography",
    metaTitle: "Destination Wedding Photographer India | DMS Productions & Films",
    metaDescription: "Premier destination wedding photography across Puri, Kolkata, Hyderabad & all-India locations. Cinematic storytelling for timeless weddings.",
    label: "Journey",
    promise:
      "From palace courtyards to coastal sunsets — we travel to capture your celebration wherever it takes us.",
    intro:
      "A destination wedding is an experience as much as a celebration. We become part of the journey, documenting not only the ceremonies but the atmosphere, the landscapes and the people who travelled to be there. Fully mobile, endlessly adaptable, and always discreet.",
    hero: IMG.hero[3],
    cover: IMG.indian[2],
    keywords: [
      "destination wedding photographer India",
      "palace wedding photographer",
      "beach wedding photographer Puri",
      "destination wedding photography Odisha",
    ],
    includes: [
      "Multi-day event coverage",
      "Travel-ready team",
      "Cinematic film add-on",
      "Drone & aerial coverage",
      "Same-day teaser edits",
      "Luxury album & keepsakes",
    ],
    process: [
      { title: "Planning", text: "We coordinate logistics, timelines and locations with your planner well in advance." },
      { title: "On Location", text: "Our team captures every event across the celebration with cinematic sensibility." },
      { title: "The Story", text: "A complete gallery, film and album that transports you back, every time." },
    ],
    gallery: [IMG.indian[3], IMG.indian[4], IMG.details[3], IMG.indian[5], IMG.couples[1], IMG.details[4]],
    relatedStories: ["rohan-ankita", "nittu"],
    relatedBlogs: ["planning-a-destination-wedding"],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
